export const extractLookups = (formLookupState, intl) => {
  const allFormThings = Object.values(formLookupState);
  let projectTypes = [];
  let productCategories = [];
  allFormThings.forEach(({ projectType, productCategory }) => {
    if (projectType) {
      projectTypes = [
        ...projectTypes,
        ...Object.keys(projectType).map((key) => ({
          id: key,
          label: intl.formatMessage({
            id: projectType[key].id,
            defaultMessage: projectType[key].fallback,
          }),
        })),
      ];
    }
    if (productCategory) {
      productCategories = [
        ...productCategories,
        ...Object.keys(productCategory).map((key) => ({
          id: key,
          label: intl.formatMessage({
            id: productCategory[key].id,
            defaultMessage: productCategory[key].fallback,
          }),
        })),
      ];
    }
  });

  return {
    projectTypes,
    productCategories,
  };
};
